export default __webpack_public_path__ + "static/media/invoice.7058921a.jpg";